"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_lite_1 = require("mobx-react-lite");

var react_sortable_hoc_1 = require("react-sortable-hoc");

var core_1 = require("@bodiless/core");

var lodash_1 = require("lodash");

var defaultUI = {
  FlowContainerEmptyWrapper: 'div'
};

var getUI = function getUI(ui) {
  if (ui === void 0) {
    ui = {};
  }

  return __assign(__assign({}, defaultUI), ui);
};

var FlowContainerEmpty$ = function FlowContainerEmpty$(ui) {
  var FlowContainerEmptyWrapper = getUI(ui).FlowContainerEmptyWrapper;
  var context = core_1.useEditContext(); // mobx has issues with destructured values
  // eslint-disable-next-line react/destructuring-assignment

  var activeClassName = context.isActive ? 'bl-border-orange-400' : 'hover:bl-border-orange-400';
  var classNames = "bl-border-2 bl-border-dashed bl-flex bl-w-full bl-justify-center \n    bl-flex-wrap bl-py-grid-3 " + activeClassName;
  return react_1.default.createElement(FlowContainerEmptyWrapper, {
    className: classNames
  }, "Empty FlowContainer");
};

var FlowContainerEmpty = lodash_1.flow(core_1.withContextActivator('onClick'), core_1.withLocalContextMenu)(FlowContainerEmpty$);
var SortableListWrapper = react_sortable_hoc_1.SortableContainer(mobx_react_lite_1.observer(function (_a) {
  var children = _a.children,
      ui = _a.ui,
      rest = __rest(_a, ["children", "ui"]);

  var content = children && children.length ? children : react_1.default.createElement(FlowContainerEmpty, null);
  return react_1.default.createElement("section", __assign({}, rest, core_1.useContextActivator()), content);
}));
SortableListWrapper.displayName = 'SortableListWrapper';

var EditListView = function EditListView(_a) {
  var onSortEnd = _a.onSortEnd,
      ui = _a.ui,
      children = _a.children,
      rest = __rest(_a, ["onSortEnd", "ui", "children"]);

  return react_1.default.createElement(SortableListWrapper, __assign({
    axis: "xy",
    useDragHandle: true,
    transitionDuration: 0,
    onSortEnd: onSortEnd,
    ui: ui
  }, rest), children);
};

EditListView.displayName = 'EditListView';
EditListView.defaultProps = {
  onSortEnd: function onSortEnd() {}
};
exports.default = EditListView;